"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StationListItem = void 0;
const react_1 = __importDefault(require("react"));
const openNow_1 = require("@geome/react-components-next/lib/components/openNow");
const StationListItem = ({ location, configPath }) => {
    var _a;
    return (react_1.default.createElement("li", { className: "station-list-item" },
        react_1.default.createElement("a", { href: location.link, className: "station-list-item__link" },
            react_1.default.createElement("h3", { className: "station-list-item__heading" }, location.name),
            react_1.default.createElement("p", { className: "station-list-item__address" }, location.formatted_address),
            location.open_status && (react_1.default.createElement(openNow_1.OpenNow, { openStatus: location.open_status, nextOpenStatusChange: (_a = location.next_open_status_change) !== null && _a !== void 0 ? _a : null, tzOffset: location.tz_offset, configPath: configPath })))));
};
exports.StationListItem = StationListItem;
